export const extractFields = (clusters = []) => {
    const fields = [];
    clusters.forEach(cluster => {
        cluster.parameterizations?.forEach(param => {
            fields.push(param);
        });
    });

    return fields;
}